import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { prepareMedia } from './utilities/media';
import { canvasEffects } from './library';
function transformProgress(p, min, max, step) {
  if (typeof p === 'number') {
    const transformed = p * max + (1 - p) * min;
    return step ? Math.round(transformed / step) * step : transformed;
  } else if (p) {
    return {
      ...(p.x !== undefined ? {
        x: transformProgress(p.x, min, max, step)
      } : {}),
      ...(p.y !== undefined ? {
        y: transformProgress(p.y, min, max, step)
      } : {}),
      ...(p.v ? {
        v: {
          ...(p.v.x !== undefined ? {
            x: transformProgress(p.v.x, min, max, step)
          } : {}),
          ...(p.v.y !== undefined ? {
            y: transformProgress(p.v.y, min, max, step)
          } : {})
        }
      } : {}),
      ...(p.active !== undefined ? {
        active: p.active
      } : {})
    };
  }
  return p;
}

/**
 * @class CanvasScene
 */
class CanvasScene {
  constructor(options, preset, target, source) {
    _defineProperty(this, "sequence", void 0);
    _defineProperty(this, "source", void 0);
    _defineProperty(this, "ready", void 0);
    _defineProperty(this, "scrubEffects", void 0);
    _defineProperty(this, "aborted", false);
    this.sequence = null;
    this.source = null;
    if (source) {
      this.ready = prepareMedia(source, source.tagName.toUpperCase()).then(_ref => {
        let {
          width,
          height
        } = _ref;
        target.width = width;
        target.height = height;
        this.source = source;
      });
    } else {
      this.ready = Promise.resolve();
    }
    this.scrubEffects = {};
    this._setSequence(target, options, preset);
  }
  _setSequence(target, options, preset) {
    this.ready = this.ready.then(async () => {
      if (this.aborted) {
        return;
      }
      this.sequence = await preset(target, options);
      if (!this.sequence) {
        return;
      }
      if (this.source) {
        this.sequence.instance.setSource(this.source);
      }
    });
  }
  addScrubEffect(range, getProgress) {
    const {
      name,
      min,
      max,
      step
    } = range;
    this.scrubEffects[name] = () => {
      var _this$sequence, _this$sequence$setter, _this$sequence$setter2;
      // @ts-expect-error
      (_this$sequence = this.sequence) == null || (_this$sequence$setter = (_this$sequence$setter2 = _this$sequence.setters)[name]) == null || _this$sequence$setter.call(_this$sequence$setter2, transformProgress(getProgress(), min, max, step));
    };
  }
  removeScrubEffect(name) {
    var _this$sequence2, _this$sequence2$sette, _this$sequence2$sette2;
    // @ts-expect-error
    (_this$sequence2 = this.sequence) == null || (_this$sequence2$sette = (_this$sequence2$sette2 = _this$sequence2.setters)[name]) == null || _this$sequence2$sette.call(_this$sequence2$sette2, name === 'mouse' || name === 'mouseIntensity' ? {
      x: 0,
      y: 0,
      v: {
        x: 0,
        y: 0
      }
    } : 0);
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete this.scrubEffects[name];
  }
  beforeDraw(time) {
    var _this$sequence3;
    (_this$sequence3 = this.sequence) == null || _this$sequence3.beforeDraw == null || _this$sequence3.beforeDraw(time);
    Object.values(this.scrubEffects).forEach(effect => effect());
  }
  play(_temp) {
    let {
      reveal = false
    } = _temp === void 0 ? {} : _temp;
    this.ready.then(() => {
      var _this$sequence4;
      (_this$sequence4 = this.sequence) == null || _this$sequence4.play({
        beforeDraw: this.beforeDraw.bind(this),
        reveal
      });
    });
  }
  pause() {
    var _this$sequence5;
    (_this$sequence5 = this.sequence) == null || _this$sequence5.instance.stop();
  }
  cancel() {
    var _this$sequence6, _this$sequence7;
    this.aborted = true;
    (_this$sequence6 = this.sequence) == null || _this$sequence6.instance.destroy();
    (_this$sequence7 = this.sequence) == null || (_this$sequence7 = _this$sequence7.worker) == null || _this$sequence7.terminate();
    this.sequence = null;
  }
  resize(width, height) {
    var _this$sequence8;
    (_this$sequence8 = this.sequence) == null || _this$sequence8.resize(width, height);
  }
}
function getCanvasScene(source, target, canvasAnimationOptions) {
  if (!canvasAnimationOptions.namedEffect) {
    return;
  }
  const name = canvasAnimationOptions.namedEffect.type;
  const preset = canvasEffects[name];
  if (!preset) {
    return;
  }
  return new CanvasScene(canvasAnimationOptions, preset, target, source);
}
export { getCanvasScene };
//# sourceMappingURL=canvas.js.map